import React from 'react';
import styles from './styles.module.scss';
import type { CustomerReview as CustomerReviewType } from '../../graphql/generated/schema';
import { AppImage } from '../../components';

export const CustomerReview: React.FC<CustomerReviewType> = ({
  customerReview,
  customerName,
  customerImage,
}) => (
  <div className={styles.container}>
    <AppImage
      imageSize="card"
      image={customerImage}
      className={styles.image}
    />
    <div>
      <p>
        &quot;
        {customerReview}
        &quot;
      </p>
      <span className={styles.customerName}>
        ~
        {' '}
        {customerName}
      </span>
    </div>
  </div>
);
